module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img77.309f9846.jpg";